import React, { useContext, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Container from "../../utils/Container";
import logo from "../../../medias/logo/logo-white.svg";
import logoSmall from "../../../medias/logo/logo-white-small.svg";
import SearchInput from "../../elements/form/SearchInput";
import { BiSearch } from "react-icons/bi";
import { BsFillTelephoneFill } from "react-icons/bs";
import { HiLocationMarker } from "react-icons/hi";
import { GiHamburgerMenu } from "react-icons/gi";
import useScrollWindow from "../../../hooks/scrollWindow";
import searchContext from "../../../dataManager/context/searchContext";
import MobileNavbar from "./MobileNavbar";
import Banner from "./Banner";
import useResizeWindow from "../../../hooks/ResizeWindow";
import { IoMdClose } from "react-icons/io";

const Navbar = (props) => {
  //context variables
  const {
    keyword,
    showMobileSearchInput,
    setShowMobileSearchInput,
    addKeyword,
    resetAllSearch,
  } = useContext(searchContext);

  //location
  let { pathname } = useLocation();

  //local state variables
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  //custom hook
  const [scrollPositionY] = useScrollWindow();
  const [size] = useResizeWindow();

  const navigate = useNavigate();

  //constants
  const SCROLL_MAX_Y = 500;

  const inputSearchRef = useRef(null);

  //some handlers
  const handleSearchValue = (value) => {
    //redirect to all products page
    navigate("/produits");

    //focus on the search input
    inputSearchRef.current.focus();

    addKeyword(value);
  };

  useEffect(() => {
    inputSearchRef.current.addEventListener("focus", (e) => {
      navigate("/produits");
    });

    if (pathname === "/produits") inputSearchRef.current.focus();
  }, []);

  return (
    <section className="fixed left-0 top-0 right-0 z-50 h-[85px]">
      <div
        className={`${
          scrollPositionY > SCROLL_MAX_Y
            ? "shadowNavbar"
            : "border-2 border-tersio md:border-secondary"
        } min-h-[60px] bg-secondary  py-5 md:h-auto lg:py-3 `}
      >
        <Container>
          <div className="flex items-center justify-between">
            <div className="flex  items-center sm:space-x-2 md:space-x-6 lg:space-x-10">
              <Link to="/">
                <img
                  src={size > 768 ? logo : logoSmall}
                  alt="Logo de nti technologie"
                  className="inline-block w-28 cursor-pointer md:w-28"
                />
              </Link>
              <SearchInput
                value={keyword}
                onChangeValue={handleSearchValue}
                type="text"
                inputRef={inputSearchRef}
                placeholder="oridinateur, souris, ram ..."
                classe="hidden md:block w-[160px] md:w-[350px] rounded"
              />
            </div>

            <div
              className={`${
                showMobileSearchInput
                  ? " translate-y-0 "
                  : "translate-y-[-200px]"
              }  items-cente fixed  left-0 top-0 flex w-full shadow-md shadow-smoot/50 transition duration-150 ease-in-out md:hidden`}
            >
              <SearchInput
                value={keyword}
                onChangeValue={handleSearchValue}
                type="text"
                placeholder="oridinateur, souris, ram ..."
                classe="w-full"
              />
              <div
                onClick={() => {
                  addKeyword("");
                  setShowMobileSearchInput(false);
                }}
                className="flex h-10 items-center justify-center bg-primary p-2"
              >
                <IoMdClose
                  color="#EAEAEA"
                  size={25}
                  className="block cursor-pointer rounded-full md:hidden"
                />
              </div>
            </div>

            <div className="hidden items-center space-x-4 lg:flex">
              <div className="flex items-center space-x-2">
                <BsFillTelephoneFill
                  color="#FFF"
                  size={23}
                  className="top-[100%] mx-auto block opacity-90"
                />
                <address className="text-sm text-smoot">6 74 65 11 12</address>
              </div>
              <div className="ml-2 flex items-center  space-x-2 border-l border-white py-1 pl-2">
                <HiLocationMarker
                  color="#FFF"
                  size={30}
                  className="top-[100%] mx-auto block opacity-90"
                />
                <address className="text-sm text-smoot">
                  <span className="block">Yaoundé</span>
                  <span className="text-xs font-semibold">
                    Bonamoussadi(Bonas)
                  </span>
                </address>
              </div>
            </div>

            <div className="ml-2 flex cursor-pointer items-center  space-x-3 sm:space-x-4 md:hidden">
              <BiSearch
                onClick={() => {
                  navigate("/produits");
                  setShowMobileSearchInput(true);
                }}
                color="#EA9128 "
                size={32}
                className="cursor-pointe"
              />
              {!isMobileOpen && (
                <GiHamburgerMenu
                  onClick={() => {
                    resetAllSearch();
                    setIsMobileOpen(true);
                  }}
                  color="#EAEAEA"
                  size={40}
                  className="cursor-pointer rounded-full text-smoot shadow-md md:hidden"
                />
              )}
            </div>
          </div>
          {isMobileOpen && (
            <MobileNavbar
              showMobileMenu={isMobileOpen}
              onSetShowMobileMenu={() => setIsMobileOpen(false)}
            />
          )}
        </Container>
      </div>
      {scrollPositionY < SCROLL_MAX_Y && <Banner />}
    </section>
  );
};

export default Navbar;
